import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This file is autogenerated. Any changes will be overwritten in next build.

const RoundHangar = props => {
  const {
    size,
    color
  } = props;
  const sizeMap = {
    sm: 20,
    md: 24,
    lg: 28
  };
  let sizeValue = size;
  if (typeof size === 'number') {
    sizeValue = size;
  } else if (typeof size === 'string') {
    sizeValue = sizeMap[size];
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: sizeValue,
    height: sizeValue,
    viewBox: "0 0 214 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M107.113 0C48.0316 0 0 48.0421 0 107.136C0 110.519 2.70552 113 5.86261 113H208.137C211.518 113 213.999 110.294 213.999 107.136C214.226 48.0421 166.193 0 107.112 0H107.113ZM152.213 101.272H62.0127V60.8984C62.0127 60.6734 62.2376 60.4469 62.4641 60.4469H151.762C151.987 60.4469 152.214 60.6719 152.214 60.8984L152.213 101.272ZM164.164 101.272V60.8984C164.164 54.1315 158.527 48.4928 151.761 48.4928H62.4633C55.6978 48.4928 50.0603 54.1315 50.0603 60.8984V101.272H11.9503C15.1072 51.4253 56.5994 11.9541 107.112 11.9541C157.624 11.9541 199.116 51.4253 202.273 101.272H164.164Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M118.135 26H95.8517C92.4761 26 90 28.7689 90 32C90 35.4611 92.7005 38 95.8517 38H118.135C121.511 38 123.987 35.2311 123.987 32C124.211 28.7691 121.511 26 118.135 26Z",
      fill: color
    })]
  });
};
export { RoundHangar };